import * as React from 'react';
import PropTypes from 'prop-types';
import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/system';

export const StyledButton = styled(LoadingButton)(({ theme }) => ({
  fontWeight: 500,
  fontSize: '1.25rem',
  lineHeight: '24px',
  letterSpacing: '0.02em',
  padding: '14px 28px',
  color: theme.palette.common.white,
  borderRadius: '8px',
  textTransform: 'inherit',
  transition: 'all 150ms ease',
  boxShadow: 'none',

  '&.MuiLoadingButton-loading.Mui-disabled': {
    color: 'transparent',

    '& > div.MuiLoadingButton-loadingIndicator': {
      '& > span': {
        width: '22px !important',
        height: '22px !important'
      }
    }
  },

  '&:hover, &:active': {
    opacity: 0.8,
    boxShadow: 'none'
  },

  '&.Mui-disabled': {
    opacity: 0.4,
    cursor: 'not-allowed',
    color: theme.palette.common.white
  },

  '&.MuiButton-sizeSmall': {
    fontSize: '1.125rem',
    padding: '8px 24px'
  },

  '&.MuiButton-containedSecondary': {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.primary
  },

  '&.MuiButton-containedPrimary': {
    backgroundColor: theme.palette.primary.main
  },

  '&.MuiButton-outlinedSecondary': {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.action.disabled}`,
    padding: '7px 12px',
    color: theme.palette.text.primary,

    '&:hover': {
      background: theme.palette.secondary.main
    },

    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[600]
    }
  },

  '&.MuiButton-outlinedError.MuiButton-sizeSmall': {
    color: theme.palette.error.main
  }
}));

export const CustomLoadingButton = ({ children, ...props }) => {
  return <StyledButton {...props}>{children}</StyledButton>;
};

CustomLoadingButton.propTypes = {
  children: PropTypes.node.isRequired
};
